import { bootstrapWidget } from "../../common";
import DescriptionWidget from "./widget";

bootstrapWidget({ widget: DescriptionWidget, widgetType: "description" });
